import React from 'react'
import { Outlet } from "react-router-dom";
const ModelConfigurationIndex = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default ModelConfigurationIndex